import React from "react";
import SessionExpiredModal from "shared/components/feedback/modals/SessionExpired";

const SessionExpired = (_props) => {
    return <SessionExpiredModal show="true" />;
};

export default SessionExpired;
